/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import "./mainGrid.css";
import "devextreme/dist/css/dx.light.css";
import TreeList, {
  Editing,
  Selection,
  Column,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  ColumnChooser,
  SearchPanel,
  Toolbar,
  Item,
  ColumnFixing,
  KeyboardNavigation,
  LoadPanel,
  Search,
  StateStoring,
  ColumnChooserSelection,
} from "devextreme-react/tree-list";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSettings,
  getMohSelectValues,
} from "../../actions";
import { SettingsModal } from "../grid/dialog/Settings/SettingsModal";
import { LogModal } from "../grid/dialog/Log/LogModal";
import {
  renderL3MvsL12M,
  renderProjectedMoHAfterL12M,
  renderProjectedMoHAfterL3M,
  rendery2y1,
  renderYoyCell,
  renderYoyStabilityCell,
  renderIconQtyCell
} from "./customCellStyle";
import {
  setCellValue,
  setCellValueAndCost,
  onCellPrepared,
  handleNodesInitialized,
  disableNumericArrows
} from "./customGridActions";
import ExportModal from "../grid/dialog/Export/ExportModal";
import {
  CalculateAdditionalMoHLoad,
  calculatePoCostApprover,
  calculatePoCostMarket,
  calculatePoReviewerCost,
  calculateRevisedPoQty,
  calculateY2ToY1,
  calculateRemainingEstMoh,
} from "../../common/formulas";
import { excelExport } from "../../common/Export";
import { GridTooltips } from "../gridTooltip/gridTooltips";
import { SaveGridTemplateDialog } from "../grid/dialog/GridTemplate/saveGridTemplate";
import { GetColumnsByGrid } from "../../common/Columns";
import { loadCurrentTemplate, validateAndCleanTemplate, saveCurrentState } from './templateManager';
import { useColumnHelpers } from './columnHelpers';
import { LinearProgress } from "@mui/material";
import PropTypes from 'prop-types';
import MohSelectBox from "./toolbar/Components/mohSelectBox";
import { getModifierValueId } from "../../common/mohFunctions";
import ToolBarButton from "./toolbar/Components/toolbarButton";
import ToolBarDropDownButton from "./toolbar/Components/toolbarDropDownButton";
import { ExportOptions } from "./Data/ExportOptions";
import { useInterval } from 'usehooks-ts'
import { clearCategoryGrid, clearGlobalGrid } from "./functions/cleanFields";
import { NetsuiteUpdateButton } from "../tools/NetsuiteUpdateButton";
import { GridSettingsModal } from "../grid/dialog/GridSettings/GridSettingsModal";
import { getGridAttributesByDefault, gridAttributesKey } from "../../common/gridSettings";
import { SumByColumn, updateColumnSum, initColumnSum, useRefSumByColumn } from "../SumByColumn/SumByColumn";
import { SumColumnsModal } from "../grid/dialog/SumColumns/SumColumnsModal";
import { presetPopup } from "../grid/dialog/presetPopup/presetPopup";
import { getPreferredVendorColumn } from "./columnsProps/preferredVendorColumn";
import { getCurrentSystemsColumn } from "./columnsProps/currentSystemsColumn";
import { getInventoryColumns } from "./columnsProps/inventoryColumns";
import { getUniqueCustomColumns } from "./columnsProps/uniqueCustomColumns";
import { getBackOrderAndCommittedColumns } from "./columnsProps/backOrderAndCommittedColumns";
import { getPurchaseOrderColumn } from "./columnsProps/purchaseOrderColumn";
import { getVendorInventoryColumn } from "./columnsProps/vendorInventoryColumn";
import { getInboundColumn } from "./columnsProps/inboundColumn";

const MainGrid = (props) => {

  MainGrid.propTypes = {
    data: PropTypes.array,
    error: PropTypes.bool,
    isLoading: PropTypes.bool,
    mutate: PropTypes.func,
    onMohModifierChange: PropTypes.func.isRequired,
    programId: PropTypes.number.isRequired,
    categoryId: PropTypes.number.isRequired,
    selectedModifier: PropTypes.number.isRequired,
  };

  const { data, error, isLoading, mutate, onMohModifierChange, programId, categoryId } = props;
  const columns = GetColumnsByGrid(1) || [];
  const dispatch = useDispatch();
  const settings = useSelector(state => state.settings.data);
  const storageKey = `storageKey-${programId}-${categoryId}`;
  const gridInstance = useRef(null);
  const user = useSelector(state => state.userInfo.userAuthenticated);
  const programsList = useSelector(state => state.userInfo.programs);
  const categoriesList = useSelector(state => state.userInfo.categories);
  const currentPermissions = useSelector(state => state.userInfo.permissions);
  const selectedRoleId = useSelector(state => state.userInfo.selectedRole);
  const currentRole = useSelector(state => state.userInfo.selectedRole);
  const groupId = `Group${programId}${categoryId}`;
  const [selectedModifier, setSelectedModifier] = useState(1);
  const [gridSettings, setGridSettings] = useState(getGridAttributesByDefault());
  const [templateError, setTemplateError] = useState(false);
  const [templateLoaded, setTemplateLoaded] = useState(false);
  // const [showGrid, setShowGrid] = useState(false);
  const incomingSignalrGridData = useSelector(state => state.signalR?.gridData);
  const [mohOptions, setMohOptions] = useState([]);

  let totalSumByColumn = initColumnSum();
  const { refSumByCol, refSumByColDisplay, setSumByColumn, getSumByColumn, setSumByColumnDisplay } = useRefSumByColumn();

  // Use column helpers from the extracted module
  const { 
    isColEditable, 
    renderColumn, 
    getColumnCode, 
    renderColumnCode 
  } = useColumnHelpers(currentPermissions);

  useEffect(() => {
    dispatch(fetchSettings(programId));
  }, [programId]);

  useEffect(() => {
    const getSelectValuesAsync = async () => {
      let mohOptions = [];
      if (!currentRole) return mohOptions;
      const gridModifiers = await getMohSelectValues(currentRole);
      if (gridModifiers) {
        mohOptions = Object.values(gridModifiers);
      }
      setMohOptions(mohOptions);
    };
    getSelectValuesAsync();
  }, [currentRole]);


  useEffect(() => {
  const loadTemplateAndUpdateGrid = async () => {
    try {
      console.log('Starting template load process:', { 
        gridInstance: !!gridInstance.current, 
        permissions: !!currentPermissions, 
        isLoading,
        storageKey 
      });
      
      // Enhanced checks for Azure environment
      if (!gridInstance.current || !currentPermissions || !Array.isArray(currentPermissions) || isLoading) {
        console.log("Grid instance, permissions not available, or grid is loading - skipping template load");
        return;
      }
      
      // Additional check to ensure grid instance is fully initialized
      if (!gridInstance.current.instance || !gridInstance.current.instance()) {
        console.log("Grid instance not fully initialized - skipping template load");
        return;
      }
      
      const template = await loadCurrentTemplate(storageKey, user, programId, categoryId);
      console.log('Template loaded:', { hasTemplate: !!template, templateType: typeof template });
      
      if (template && gridInstance.current) {
        // Use longer delay for Azure environment with better error handling
        const delay = window.location.hostname.includes('azurewebsites.net') ? 1000 : 750;
        
        setTimeout(() => {
          try {
            if (gridInstance.current && gridInstance.current.instance && gridInstance.current.instance()) {
              // Verify the grid is in a stable state before applying template
              const gridInstance_api = gridInstance.current.instance();
              
              // More defensive check - ensure grid API is fully loaded
              if (gridInstance_api.getDataSource && typeof gridInstance_api.state === 'function') {
                // Validate template before applying
                const validatedTemplate = validateAndCleanTemplate(template, currentPermissions);
                console.log('Applying validated template with columns:', validatedTemplate.columns?.length || 0);
                
                // Apply the loaded template to the grid using standard DevExtreme state management
                gridInstance_api.state(validatedTemplate);
                console.log("Template applied to grid successfully");
                setTemplateError(false); // Reset error state on successful application
                setTemplateLoaded(true); // Mark template as successfully loaded
              } else {
                console.log("Grid API methods not ready, postponing template application");
                // Try again after a longer delay for Azure
                setTimeout(() => {
                  if (gridInstance.current && gridInstance.current.instance) {
                    try {
                      const retryApi = gridInstance.current.instance();
                      if (retryApi && retryApi.state) {
                        const validatedTemplate = validateAndCleanTemplate(template, currentPermissions);
                        retryApi.state(validatedTemplate);
                        setTemplateError(false);
                        setTemplateLoaded(true);
                        console.log("Template applied on retry");
                      }
                    } catch (retryError) {
                      console.error("Retry template application failed:", retryError);
                      setTemplateError(true);
                      setTemplateLoaded(true);
                    }
                  }
                }, 2000); // Longer retry delay for Azure
              }
            }
          } catch (templateError) {
            console.error("Error applying template:", templateError);
            setTemplateError(true);
            setTemplateLoaded(true); // Allow grid to continue even if template fails
          }
        }, delay);
      } else {
        console.log("No template to apply or grid instance not available");
        setTemplateLoaded(true); // Allow grid to render without template
      }
    } catch (error) {
      console.error("Error in loadTemplateAndUpdateGrid:", error);
      setTemplateError(true);
      setTemplateLoaded(true); // Ensure grid can still load
    }
  };

  loadTemplateAndUpdateGrid();
}, [storageKey, currentPermissions, isLoading, user, programId, categoryId]);

  useEffect(() => {
    const updateGridData = async () => {
      if (incomingSignalrGridData) {
        if (gridInstance) {
          let dataSource = gridInstance.current.instance().getDataSource();
          const store = dataSource.store();
          try {
            await store.update(incomingSignalrGridData.keyItem, { [incomingSignalrGridData.fieldName]: incomingSignalrGridData.fieldValue });
            dataSource.load();
          } catch (error) {
            console.error(error);
          }
        }
      }
    };

    updateGridData();
  }, [incomingSignalrGridData, programId, categoryId, gridInstance]);

  useInterval(
    () => {
      const saveTemplate = async () => {
        try {
          if (gridInstance.current && 
              gridInstance.current.instance && 
              gridInstance.current.instance() && 
              !templateError &&
              !isLoading) {
            
            // Fix: Pass gridInstance and storageKey in correct order
            await saveCurrentState(gridInstance.current, storageKey);
          }
        } catch (error) {
          console.error('Error saving current template:', error);
        }
      };
      
      // Only save if we're not in the middle of loading
      if (!isLoading) {
        saveTemplate();
      }
    },
    // Azure-optimized interval: longer in Azure environment
    window.location.hostname.includes('azurewebsites.net') ? 60000 : 30000
  );

  const showLogDialog = (e) => {
    openPopupLog({ internalId: e.row.data.InternalId, name: e.row.data.Name, categoryId: e.row.data.categoryId, programId: e.row.data.programId });
  };

  const showExportDialog = () => {
    openPopupExport();
  };

  const showPreferences = () => {
    openPopupSettings();
  };

  const showSumColumns = () => {
    openPopupSumColumns();
  };

  const showSaveColumnConfiguration = () => {
    openPopupSaveColumnConfiguration();
  };

  const handleSaveSettings = () => {
    closePopupSettings();
    mutate();
    dispatch(fetchSettings(programId));
  };

  const showGridSettings = () => {
    openPopupGridSettings({ ...gridSettings });
  };

  const handleSaveGridSettings = ({ columnLines, rowLines, borders, rowAlternation }) => {
    const gridAttributes = { columnLines, rowLines, borders, rowAlternation };
    setGridSettings(gridAttributes);
    localStorage.setItem(gridAttributesKey, JSON.stringify(gridAttributes));
    closePopupGridSettings();
  };

  const recalculateValues = (value) => {
    const selectedValue = getModifierValueId(value);
    onMohModifierChange(selectedValue);
    setSelectedModifier(selectedValue);
  };

  const cleanUpdateFields = () => {
    const cleanUpdateFieldsAsync = async () => {
      if (programId === 0 && categoryId === 0) {
        await clearGlobalGrid(data, mutate, selectedRoleId, categoriesList, gridInstance, currentPermissions);
      }
      else {
        await clearCategoryGrid(data, mutate, programId, categoryId, currentPermissions);
      }
    }
    cleanUpdateFieldsAsync();
  };

  const handleTemplateChangeLocal = (currentTemplate) => {
    try {
      if (!gridInstance.current || !gridInstance.current.instance) {
        console.warn('Grid instance not available for template change');
        return;
      }

      const gridApi = gridInstance.current.instance();
      
      // Handle template reset (when currentTemplate is null)
      if (currentTemplate === null) {
        console.log('Resetting grid to default state');
        // Reset grid to default state by clearing the state
        setTimeout(() => {
          try {
            // Reset to empty state which will show all columns with default settings
            gridApi.state({});
            setTemplateError(false);
            console.log('Grid reset to default state successfully');
          } catch (error) {
            console.error('Error resetting grid to default state:', error);
            setTemplateError(true);
          }
        }, 100);
        return;
      }

      if (currentTemplate && typeof gridApi.state === 'function') {
        // Parse template if it's a string
        let parsedTemplate = currentTemplate;
        if (typeof currentTemplate === 'string') {
          try {
            parsedTemplate = JSON.parse(currentTemplate);
          } catch (parseError) {
            console.error('Error parsing template:', parseError);
            setTemplateError(true);
            return;
          }
        }

        // Validate and clean the template
        const validatedTemplate = validateAndCleanTemplate(parsedTemplate, currentPermissions);
        
        // Apply template with Azure-specific delay
        const delay = window.location.hostname.includes('azurewebsites.net') ? 1000 : 100;
        
        setTimeout(() => {
          try {
            gridApi.state(validatedTemplate);
            setTemplateError(false);
            console.log('Template applied successfully via handleTemplateChangeLocal');
          } catch (error) {
            console.error('Error applying template:', error);
            setTemplateError(true);
          }
        }, delay);
      }
    } catch (error) {
      console.error('Error in handleTemplateChangeLocal:', error);
      setTemplateError(true);
    }
  };

  const onContentReady = () => {
    updateColumnSum(totalSumByColumn, setSumByColumn, getSumByColumn, setSumByColumnDisplay);
  };

  const onNodesInitialized = (e) => {
    totalSumByColumn = handleNodesInitialized(e);
    updateColumnSum(totalSumByColumn, setSumByColumn, getSumByColumn, setSumByColumnDisplay);
  };


  const showExport = (e) => {
    let selectedOption = e.itemData.id;
    if (selectedOption === 1) {
      let currentData = [];
      gridInstance.current.instance().forEachNode((x) =>
        x.visible === true ? currentData.push(x.data) : ""
      );
      excelExport(gridInstance.current.instance(), currentData);
    } else if (selectedOption === 2) {
      showExportDialog();
    }
  };


  const saleAmountEditorOptions = { format: '$#,##0.##', showClearButton: true };  const headerCellRender = (data) => {
    let text = data.column.caption;
    return <p style={{ whiteSpace: "normal" }}>{text}</p>;
  };

  const onEditorPreparing = (e) => {
    disableNumericArrows(e);
  };

  const getProgramName = (rowData, programsList) => {
    const programId = rowData["programId"];
    if (programId === null) return null;
    const program = programsList.find((x) => x.programId === programId);
    return program ? program.name : null;
  }

  const getCategoryName = (rowData, CategoryList) => {
    const programId = rowData["programId"];
    const categoryId = rowData["categoryId"];
    if (programId === null || categoryId === null) return null;
    const programCategories = CategoryList[programId];
    if (!programCategories) return null;
    const category = programCategories.find((x) => x.categoryId === categoryId);
    return category ? category.categoryName : null;
  }

  const addMenuItems = (e) => {
    if (e.row?.rowType === "data") {
      // e.items can be undefined
      if (!e.items) e.items = [];
      // Add a custom menu item
      e.items.push({
        text: 'View Editable Fields Log',
        onItemClick: () => {
          if (e.row.rowType === "data") {
            showLogDialog(e);
          }
        }
      });
      if (programId === 0 && categoryId === 0) {
        e.items.push(
          {
            text: 'Settings',
            onItemClick: () => {
              openPopupSettings({ programId: e.row.data.programId, categoryId: e.row.data.categoryId });
            }
          });
      }
    }
  }


  const onEditingStart = (e) => {
    if (!categoriesList[e.data.programId].find(x => x.categoryId === e.data.categoryId)) {
      e.cancel = true;
    }
  }

  const filterBySelectedRows = (e) => {
    const selectedRows = gridInstance.current.instance().getSelectedRowsData();
    const selectedNames = selectedRows.map(x => x.Name);
    gridInstance.current.instance().columnOption("Name", "filterValues", selectedNames)
  }

  const { render: LogModalRender, openPopup: openPopupLog } = presetPopup({ Popup: LogModal });
  const { render: ExportModalRender, openPopup: openPopupExport } = presetPopup({ Popup: ExportModal });
  const { render: GridSettingsModalRender, openPopup: openPopupGridSettings, closePopup: closePopupGridSettings } = presetPopup({ Popup: GridSettingsModal, props: { onSavedData: handleSaveGridSettings } });
  const { render: SumColumnsModalRender, openPopup: openPopupSumColumns } = presetPopup({ Popup: SumColumnsModal, props: { getSumByColumn, refSumByColDisplay } });
  const { render: SettingsModalRender, openPopup: openPopupSettings, closePopup: closePopupSettings } = presetPopup({
    Popup: SettingsModal,
    props: { programId: programId, categoryId: categoryId, onSavedData: handleSaveSettings }
  });
  const { render: SaveGridTemplateDialogRender, openPopup: openPopupSaveColumnConfiguration } = presetPopup({
    Popup: SaveGridTemplateDialog,
    props: { 
      programId: programId, 
      categoryId: categoryId, 
      userId: user?.id, 
      storageKey: storageKey, 
      onTemplateChange: handleTemplateChangeLocal,
      gridInstance: gridInstance
    }
  });

  const { render: PreferredVendorModalRender, colProps: columnPreferredVendor } = getPreferredVendorColumn();
  const { render: ActiveKitsModalRender, colProps: columnCurrentSystems } = getCurrentSystemsColumn();
  const { render: InventoryModalRender, colProps: inventoryColumns } = getInventoryColumns();
  const { render: UniqueCustomerModalRender, colProps: uniqueCustomColumns } = getUniqueCustomColumns();
  const { render: BackModalRender, colProps: bOAndCommittedTotalColumns } = getBackOrderAndCommittedColumns();
  const { render: PurchaseOrderModalRender, colProps: purchaseOrderColumn } = getPurchaseOrderColumn();
  const { render: VendorInventoryModalRender, colProps: vendorInventoryColumn } = getVendorInventoryColumn();
  const { render: ConsolidateModalRender, colProps: inboundColumn } = getInboundColumn();
  
  const col_preferredVendor = getColumnCode(columnPreferredVendor);
  const col_activeKits = getColumnCode(columnCurrentSystems);
  const col_qohTotal = inventoryColumns ? getColumnCode(inventoryColumns['col_qohTotal']) : null;
  const col_qohCa = inventoryColumns ? getColumnCode(inventoryColumns['col_qohCa']) : null;
  const col_qohNC = inventoryColumns ? getColumnCode(inventoryColumns['col_qohNC']) : null;
  const col_availTotal = inventoryColumns ? getColumnCode(inventoryColumns['col_availTotal']) : null;
  const col_availCA = inventoryColumns ? getColumnCode(inventoryColumns['col_availCA']) : null;
  const col_availNC = inventoryColumns ? getColumnCode(inventoryColumns['col_availNC']) : null;
  const col_mod = inventoryColumns ? getColumnCode(inventoryColumns['col_mod']) : null;
  const col_availPoModBo = inventoryColumns ? getColumnCode(inventoryColumns['col_availPoModBo']) : null;
  const col_refinish = inventoryColumns ? getColumnCode(inventoryColumns['col_refinish']) : null;
  const col_scrDent = inventoryColumns ? getColumnCode(inventoryColumns['col_scrDent']) : null;

  const col_y3 = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_y3']) : null;
  const col_y2 = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_y2']) : null;
  const col_y1 = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_y1']) : null;
  const col_y0 = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_y0']) : null;
  const col_l12M = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_l12M']) : null;
  const col_l3M = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_l3M']) : null;
  const col_uniqueCustomerCount = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_uniqueCustomerCount']) : null;
  const col_topBuyerShare = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_topBuyerShare']) : null;
  const col_topBuyerName = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_topBuyerName']) : null;
  const col_exclusions = uniqueCustomColumns ? getColumnCode(uniqueCustomColumns['col_exclusions']) : null;

  const col_commitTotal = bOAndCommittedTotalColumns ? getColumnCode(bOAndCommittedTotalColumns['col_commitTotal']) : null;
  const col_boTotal = bOAndCommittedTotalColumns ? getColumnCode(bOAndCommittedTotalColumns['col_boTotal']) : null;
  const col_poTotal = purchaseOrderColumn ? getColumnCode(purchaseOrderColumn['col_poTotal']) : null;
  const col_ljlInventory = vendorInventoryColumn ? getColumnCode(vendorInventoryColumn['col_ljlInventory']) : null;
  const col_inbound = inboundColumn ? getColumnCode(inboundColumn['col_inbound']) : null;
  const colSet = {
    col_preferredVendor, col_activeKits,
    col_qohTotal, col_qohCa, col_availTotal, col_qohNC, col_availCA, col_availNC, col_mod, col_availPoModBo, col_refinish, col_scrDent,
    col_y3, col_y2, col_y1, col_y0, col_l12M, col_l3M, col_uniqueCustomerCount, col_topBuyerShare, col_topBuyerName, col_exclusions,
    col_commitTotal, col_boTotal,
    col_poTotal,
    col_ljlInventory,
    col_inbound,
  };

  if (error) return <div>Failed to load</div>;
  if (isLoading) {
    return (
      <div style={{ paddingTop: "5px" }}>
        <LinearProgress /> Loading...{" "}
      </div>
    );
  }

  const refreshGrid = () => {
    setTemplateError(false); // Reset template error state on manual refresh
    setTemplateLoaded(false); // Allow template reloading
    mutate();
  }

  return (
    <>
      <SumByColumn refSumByCol={refSumByCol} />
      <div className="main-grid-scroll-container">
        {(!currentPermissions || !Array.isArray(currentPermissions)) ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>Loading grid permissions...</p>
          </div>
        ) : (
          <TreeList
            visible={!isLoading}
            height={"80vh"}
            ref={gridInstance}
            dataSource={data}
            showColumnLines={gridSettings.columnLines}
            showBorders={gridSettings.borders}
            showRowLines={gridSettings.rowLines}
            rowAlternationEnabled={gridSettings.rowAlternation}
            onNodesInitialized={onNodesInitialized}
          onContentReady={onContentReady}
          allowColumnResizing={true}
          columnResizingMode="widget"
          keyExpr="keyItem"
          parentIdExpr="ParentID"
          id="items"
          onCellPrepared={(e) => onCellPrepared(e, settings, categoriesList)}
          onContextMenuPreparing={addMenuItems}
          filterMode={"withAncestors"}
          autoExpandAll={true}
          allowColumnReordering={true}
          style={{ margin: "1vw", maxHeight: "90vh", maxWidth: "95vw" }}
          onEditorPreparing={onEditorPreparing}
          wordWrapEnabled={false}
          onColumnsChange={(e) => console.log(e)}
          onEditingStart={onEditingStart}
          width="100vw"
          columnHidingEnabled={true}
        >
          <KeyboardNavigation
            editOnKeyPress={true}
            enterKeyAction={"moveFocus"}
            enterKeyDirection={"column"}
          />
          <StateStoring 
            enabled={false} 
            type="localStorage" 
            storageKey={storageKey} 
          />
          <SearchPanel visible={true} width={250} />
          <LoadPanel enabled={false} />
          <ColumnChooser
            enabled={true}
            mode={"select"}
            sortOrder={"asc"}
            height={"50vh"}
          >
            <ColumnChooserSelection
            allowSelectAll={true}
            selectByClick={true}
            recursive={true} />
            <Search enabled={true} />
          </ColumnChooser>
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true} />
          <Selection mode="multiple" selectAllMode={"allPages"} />
          <Editing mode="cell" allowUpdating={true} />
          <Scrolling mode="virtual" rowRenderingMode="virtual" />
          <Toolbar>
            <Item location="before" locateInMenu="auto">
              <NetsuiteUpdateButton origin={`grid-${groupId}`} />
            </Item>
            {programId !== 0 && categoryId !== 0 ?
              <Item location="before" locateInMenu="auto">
                <ToolBarButton code="Settings" location="before" icon="preferences" action={showPreferences} tooltipText="Settings for the current Program and Category" />
              </Item>
              : ""
            }
            <Item location="before" locateInMenu="auto">
              <ToolBarDropDownButton code="Download Data" location="before" icon="exportxlsx" action={showExport} ExportOptions={ExportOptions} />
            </Item>
            <Item location="before" locateInMenu="auto">
              <ToolBarButton code="Delete Data" location="before" icon="clearformat" action={cleanUpdateFields} tooltipText="Clears user entered data for the current Program and Category." />
            </Item>
            <Item location="before" locateInMenu="auto">
              <ToolBarButton code="templates" location="before" icon="save" action={showSaveColumnConfiguration} tooltipText="Setup, share, or load a saved view/filter/template for the data grid." validatePermission={false} />
            </Item>
            <Item location="before" locateInMenu="auto">
              <MohSelectBox mohOptions={mohOptions} selectedModifier={selectedModifier} onSelectedMohChanged={(e) => recalculateValues(e.value)} />
            </Item>
            <Item location="before" locateInMenu="auto">
              <ToolBarButton code="filterSelected" location="before" icon="filter" action={filterBySelectedRows} tooltipText="filter by selected rows" validatePermission={false} />
            </Item>
            <Item location="before" locateInMenu="auto">
              <ToolBarButton code="refreshGrid" location="before" icon="refresh" action={refreshGrid} tooltipText="Refresh Grid" validatePermission={false} />
            </Item>
            <Item location="after" locateInMenu="auto">
              <ToolBarButton code="DataGridSumColumns" icon="datafield" action={showSumColumns} tooltipText="Sum of columns" validatePermission={false} />
            </Item>
            <Item location="after" locateInMenu="auto">
              <ToolBarButton code="DataGridLineSettings" icon="tableproperties" action={showGridSettings} tooltipText="Grid styles" validatePermission={false} />
            </Item>
            <Item name="columnChooserButton" locateInMenu="auto" />
            <Item name="searchPanel" locateInMenu="auto" />
          </Toolbar>
          {renderColumn("col_id", <Column caption="id" allowEditing={false} dataField="Id" dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} visible={false} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_name", <Column caption="Name" allowHiding={false} allowEditing={false} dataField="Name" dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_program", <Column caption="Program" allowHiding={true} allowEditing={false} dataField="programId" dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} calculateCellValue={(rowData) => getProgramName(rowData, programsList)} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_category", <Column caption="Category" allowHiding={true} allowEditing={false} dataField="categoryId" dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} calculateCellValue={(rowData) => getCategoryName(rowData, categoriesList)} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_internalid", <Column icon="refresh" allowHiding={true} caption="Internal ID" allowEditing={false} dataField="InternalId" dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_description", <Column dataField="Description" caption="Sales Description" allowEditing={false} dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_purchaseDescription", <Column dataField="purchaseDescription" caption="Purchase Description" allowEditing={false} dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_exclusivity", <Column caption="Exclusivity" allowEditing={false} dataField="Exclusivity" dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_purchasePrice", <Column dataField="Purchase Price" caption="Purchase Price" allowEditing={false} dataType={"number"} format={'$#,##0.##'} editorOptions={saleAmountEditorOptions} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumnCode('col_preferredVendor', colSet)}
          {renderColumn("col_universalProductType", <Column dataField="universalProductType" caption="Universal Product Type" allowEditing={false} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_groupNotes", <Column dataField="Group Notes" allowEditing={false} dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_inactive", <Column dataField="Inactive" allowEditing={false} dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_discontinued1", <Column dataField="Discontinued 1" allowEditing={false} dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_replacedBy", <Column dataField="replacedBy" caption="Replaced By" allowEditing={false} dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_replaces", <Column dataField="replaces" caption="Replaces" allowEditing={false} dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumnCode('col_qohTotal', colSet)}
          {renderColumnCode('col_qohCa', colSet)}
          {renderColumnCode('col_qohNC', colSet)}
          {renderColumnCode('col_availTotal', colSet)}
          {renderColumnCode('col_availCA', colSet)}
          {renderColumnCode('col_availNC', colSet)}
          {renderColumnCode('col_poTotal', colSet)}
          {renderColumnCode('col_commitTotal', colSet)}
          {renderColumnCode('col_boTotal', colSet)}
          {renderColumnCode('col_mod', colSet)}
          {renderColumnCode('col_availPoModBo', colSet)}
          {renderColumnCode('col_inbound', colSet)}
          {renderColumnCode('col_refinish', colSet)}
          {renderColumnCode('col_scrDent', colSet)}
          {renderColumnCode('col_ljlInventory', colSet)}
          {renderColumnCode('col_y3', colSet)}
          {renderColumnCode('col_y2', colSet)}
          {renderColumnCode('col_y1', colSet)}
          {renderColumnCode('col_y0', colSet)}
          {renderColumn("col_yTotal", <Column dataField="Y_Total" caption={"STLY History"} allowEditing={false} cellRender={renderYoyCell} alignment="center" dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_yoyStability", <Column dataField="YoY_Stability" caption="YOY Stability" cellRender={renderYoyStabilityCell} allowEditing={false} alignment="center" dataType={"string"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_y2_to_y1", <Column dataField="y2ToY1" caption="Y2 To Y1" alignment="right" calculateCellValue={calculateY2ToY1} cellRender={rendery2y1} allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumnCode('col_l12M', colSet)}
          {renderColumnCode('col_l3M', colSet)}
          {renderColumn("col_l12MAvg", <Column dataField="L12MAvg" caption="L12M Avg" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_l3MAvgM", <Column dataField="L3M Avg" caption="L3M Avg" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_l3MvsL12M", <Column dataField="L3M vs L12M" caption="L3M vs L12M" allowEditing={false} cellRender={renderL3MvsL12M} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumnCode('col_activeKits', colSet)}
          {renderColumn("col_activePublic", <Column dataField="ActivePublic" caption="Public Systems" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_activeNoPublic", <Column dataField="ActiveNoPublic" caption="Non-Public Systems" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumnCode('col_uniqueCustomerCount', colSet)}
          {renderColumnCode('col_topBuyerShare', colSet)}
          {renderColumnCode('col_topBuyerName', colSet)}
          {renderColumn("col_minOrderQuantity", <Column dataField="minOrderQuantity" caption="Min Order Quantity" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_maxOrderQuantity", <Column dataField="maxOrderQuantity" caption="Max Order Quantity" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_reorderMultiple", <Column dataField="reorderMultiple" caption="Reorder Multiple" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_lowMoh", <Column dataField="Low MoH" caption="Low Est Qty Defecit" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_midMoh", <Column dataField="Mid MoH" caption="Mid Est Qty Defecit" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_targetMoh", <Column dataField="Target MoH" caption="Target MOH Qty Defecit" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_suggestedPoQty", <Column dataField="Suggested PO Qty" allowEditing={false} dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_costSuggested", <Column dataField="CostSuggested" caption="Suggested PO Cost" allowEditing={false} dataType={"number"} format={'$#,##0.##'} editorOptions={saleAmountEditorOptions} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_poQtyReviewer", <Column dataField="poQtyReviewer" dataType="number" caption="PO Qty Reviewer" cellRender={(data) => renderIconQtyCell(data, "Suggested PO Qty")} allowEditing={isColEditable("col_poQtyReviewer")} setCellValue={async (newData, value, currentRowData) => await setCellValueAndCost(newData, value, currentRowData, "poQtyReviewer", "poQtyReviewer", "I", user.id, "CostReviewer")} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_poNotesReviewer", <Column dataField="poNotesReviewer" dataType={"string"} caption="PO Notes Reviewer" allowEditing={isColEditable("col_poNotesReviewer")} setCellValue={async (newData, value, currentRowData) => await setCellValue(newData, value, currentRowData, "poNotesReviewer", "poNotesReviewer", "V", user.id)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_costReviewer", <Column dataField="CostReviewer" caption="Reviewer PO Cost" allowEditing={false} calculateCellValue={calculatePoReviewerCost} format={'$#,##0.##'} editorOptions={saleAmountEditorOptions} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_poQtyMarket", <Column dataField="poQtyMarket" dataType="number" caption="PO Qty Market" cellRender={(data) => renderIconQtyCell(data, "Suggested PO Qty")} allowEditing={isColEditable("col_poQtyMarket")} setCellValue={async (newData, value, currentRowData) => await setCellValueAndCost(newData, value, currentRowData, "poQtyMarket", "poQtyMarket", "I", user.id, "CostMarket")} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_poNotesMarket", <Column dataField="poNotesMarket" dataType={"string"} caption="PO Notes Market" allowEditing={isColEditable("col_poNotesMarket")} setCellValue={async (newData, value, currentRowData) => await setCellValue(newData, value, currentRowData, "poNotesMarket", "poNotesMarket", "V", user.id)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_costMarket", <Column dataField="CostMarket" dataType="number" caption="Market PO Cost" allowEditing={false} calculateCellValue={calculatePoCostMarket} format={'$#,##0.##'} editorOptions={saleAmountEditorOptions} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_poQtyApprover", <Column dataField="poQtyApprover" dataType="number" caption="PO Qty Approver" cellRender={(data) => renderIconQtyCell(data, "Suggested PO Qty")} allowEditing={isColEditable("col_poQtyApprover")} setCellValue={async (newData, value, currentRowData) => await setCellValueAndCost(newData, value, currentRowData, "poQtyApprover", "poQtyApprover", "I", user.id, "CostApprover")} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_poNotesApprover", <Column dataField="poNotesApprover" dataType={"string"} caption="PO Notes Approver" allowEditing={isColEditable("col_poNotesApprover")} setCellValue={async (newData, value, currentRowData) => await setCellValue(newData, value, currentRowData, "poNotesApprover", "poNotesApprover", "V", user.id)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_costApprover", <Column dataField="CostApprover" dataType="number" caption="Approver PO Cost" allowEditing={false} calculateCellValue={calculatePoCostApprover} format={'$#,##0.##'} editorOptions={saleAmountEditorOptions} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_additionalMohL3ML12MLoad", <Column dataField="additionalMohL3ML12MLoad" caption="Additional MoH Load (L12M | L3M)" allowEditing={false} calculateCellValue={(rowData) => CalculateAdditionalMoHLoad(rowData, selectedModifier)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_remainingEstMoh12M", <Column dataType="number" dataField="Remaining Est MoH L12M" caption="Remaining Est MoH L12M" allowEditing={false} calculateCellValue={(rowData) => calculateRemainingEstMoh(rowData, 12)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_projectedMohAfterPoL12M", <Column dataType="number" dataField="Projected MoH after PO L12M" caption="Projected MoH after PO L12M" allowEditing={false} cellRender={(data) => renderProjectedMoHAfterL12M(data, settings)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_remainingEstMoh3M", <Column dataType="number" dataField="Remaining Est MoH L3M" caption="Remaining Est MoH L3M" allowEditing={false} calculateCellValue={(rowData) => calculateRemainingEstMoh(rowData, 3)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_projectedMohAfterPoL3M", <Column dataType="number" dataField="Projected MoH after PO L3M" caption="Projected MoH after PO L3M" allowEditing={false} cellRender={(data) => renderProjectedMoHAfterL3M(data, settings)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_revisedPoQty", <Column dataField="Revised PO Qty" caption="Revised PO Qty" allowEditing={false} calculateCellValue={(rowData) => calculateRevisedPoQty(rowData, selectedModifier)} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_updatedDate", <Column caption="Updated Date" allowEditing={false} dataField="UpdatedDate" format={"yyyy-MM-dd hh:mm:ss"} dataType={"date"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_createdDate", <Column dataField="CreatedDate" caption="Creation Date" allowEditing={false} format={"yyyy-MM-dd hh:mm:ss"} dataType={"date"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumn("col_itemAge", <Column caption="Age (Months)" allowEditing={false} dataField="Age" dataType={"number"} headerCellRender={(data) => headerCellRender(data)} width={100} ><HeaderFilter ><Search enabled={true} /></HeaderFilter></Column>)}
          {renderColumnCode('col_exclusions', colSet)}
        </TreeList>
        )}
      </div>
      <GridTooltips columns={columns} />
      {LogModalRender}
      {ExportModalRender}
      {GridSettingsModalRender}
      {SaveGridTemplateDialogRender}
      {SumColumnsModalRender}
      {SettingsModalRender}
      {PreferredVendorModalRender}
      {ActiveKitsModalRender}
      {InventoryModalRender}
      {UniqueCustomerModalRender}
      {BackModalRender}
      {PurchaseOrderModalRender}
      {VendorInventoryModalRender}
      {ConsolidateModalRender}
    </>
  );
};

export default MainGrid;

